import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import loginImage from "../assets/login.png";
import { url } from "../constants/url";

const LoginPage = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); // Clear previous errors

    try {
      const response = await fetch(url + "/api/admin/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: username,
          password: password
        })
      });
      console.log("response", response);
      const data = await response.json();
      if(response.status===200)
      {

        localStorage.setItem("auth", "true");
        localStorage.setItem("token", data.token);
        navigate("/");
      }

      if (!response.ok || data.role !== "admin") {
        setError(data.message || "Invalid credentials. Please try again.");
        return;
      }

      // localStorage.setItem("auth", "true");
      // localStorage.setItem("token", data.token);
      // navigate("/");
    } catch (err) {
      console.error("Login error:", err);
      setError("An error occurred during login. Please try again later.");
    }
  };

  return (
    <div className="flex flex-col md:flex-row h-screen">
      <div
        className="w-full md:w-1/3 bg-cover bg-center"
        style={{ backgroundImage: `url(${loginImage})` }}
      >
        {/* Left-side image */}
      </div>
      <div className="w-full md:w-2/3 flex items-center justify-center p-6 md:p-8 bg-gray-100">
        <div className="max-w-md w-full bg-white rounded-3xl shadow-md p-8">
          <h2 className="text-3xl font-semibold text-center mb-6">Login</h2>
          <form className="space-y-6" onSubmit={handleLogin}>
            {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
            <div>
              <label className="block text-lg font-medium text-gray-700 mb-2">
                Email
              </label>
              <input
                type="email"
                className="w-full p-3 border rounded-3xl focus:outline-none focus:ring-2 focus:ring-[#AF9C80]"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="block text-lg font-medium text-gray-700 mb-2">
                Password
              </label>
              <div className="relative">
                <input
                  type={passwordVisible ? "text" : "password"}
                  className="w-full p-3 border rounded-3xl focus:outline-none focus:ring-2 focus:ring-[#AF9C80]"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <div
                  className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                  onClick={togglePasswordVisibility}
                >
                  {passwordVisible ? (
                    <FaEyeSlash className="text-gray-500" />
                  ) : (
                    <FaEye className="text-gray-500" />
                  )}
                </div>
              </div>
            </div>
            <div>
              <button
                type="submit"
                className="w-full p-3 bg-[#AF9C80] text-white font-semibold rounded-3xl shadow-md hover:bg-[#998970] focus:outline-none focus:ring-2 focus:ring-[#AF9C80]"
              >
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
